import { Task } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseTaskAction, addOrReplaceCaseTasksAction, deleteCaseTaskAction, setCaseTasksAction } from '../reducers/caseTaskReducer';

export const useCaseTaskActions = () => {

    const dispatch = useAppDispatch();
    
    const addOrReplaceCaseTask = (task: Task) => {
        dispatch(addOrReplaceCaseTaskAction(task));
    }
    const addOrReplaceCaseTasks = (tasks: Task[]) => {
        dispatch(addOrReplaceCaseTasksAction(tasks));
    }

    const setCaseTasks = (tasks: Task[]) => {
        dispatch(setCaseTasksAction(tasks));
    }

    const removeCaseTask = (taskId: string) => {
        dispatch(deleteCaseTaskAction(taskId));
    }

    return { addOrReplaceCaseTask, addOrReplaceCaseTasks, setCaseTasks, removeCaseTask };
}
